import moment from 'moment';

export default {
	methods: {
		formattedTime(time) {
			let d = "";
			let h = parseInt(time / 60 / 60);
			let m = parseInt((time / 60) % 60);
			if (m < 10) {
				m = "0" + m;
			}

			if (h > 10000) {
				d = parseInt(h / 24) + "Tage ";
				h = h % 24;
				return d
			}

			return [h, m].join(':') + "h";
		},
		dateWithFormat(date, format = "DD.MM.YYYY") {
			return moment(date).format(format);
		}
	}
}
